class SpotTheBall {
    constructor() {
        this.toggleDisplay = this.toggleDisplay.bind(this)
        this.toggleSscrollable = this.toggleSscrollable.bind(this)
        this.progressSlide = this.progressSlide.bind(this)
        this.addMarker = this.addMarker.bind(this)

        const stbs = document.querySelectorAll(".spot-the-ball")
        
        if (stbs.length > 0 ) {
            stbs.forEach(stb => {
                const spotTheBallPopup = stb.querySelector('.spot-the-ball\\:wrapper');
                const canvas = stb.querySelector('.spot-the-ball\\:stage\\:canvas');

                canvas.addEventListener("click", (e)=> {
                    this.addMarker(e,stb);
                })

                const progressSlideBtns = stb.querySelectorAll(".progress-slide");

                progressSlideBtns.forEach(btn => {
                    btn.addEventListener("click", (e) => {
                        e.preventDefault();
                        this.progressSlide(spotTheBallPopup);
                    });
                });

            })
        }
    }
    addMarker(e,stb) {
        const canvas = stb.querySelector('.spot-the-ball\\:stage\\:canvas');
        const marker = stb.querySelector('.user-marker');

        const rect = canvas.getBoundingClientRect();
        const hiddenField = stb.querySelector('.gfield .gform_hidden');

        let xCo = e.clientX - rect.left;
        let yCo = e.clientY - rect.top;

        marker.style.left = xCo + 'px';
        marker.style.top = yCo + 'px';

        const xPercentage = (xCo / rect.width) * 100;
        const yPercentage = (yCo / rect.height) * 100;

        if (hiddenField) {
            hiddenField.value = xPercentage + ',' + yPercentage;  
        }

        if (stb.querySelector('.spot-the-ball\\:messaging').dataset.active == "1") {
            this.progressMessage(stb);
        }
        
    }

    progressMessage(el) {
        const messages = el.querySelector('.spot-the-ball\\:messaging');
        const activeMessage =  el.querySelector('.spot-the-ball\\:messaging .active');
        let act = new Number(messages.dataset.active);

        messages.dataset.active = act + 1;

        activeMessage.classList.remove('active');
        messages.children[act].classList.add('active');
    } 
    progressSlide(el) {

        const stage = el.querySelector('.spot-the-ball\\:stage');
        const activeSlide = el.querySelector('.spot-the-ball\\:stage .active');

        const mess = el.querySelector('.spot-the-ball\\:messaging');
        const activeMessage =  el.querySelector('.spot-the-ball\\:messaging .active');

        let act = new Number(stage.dataset.active);

        mess.querySelector('.g-form-wrapper').style.minHeight = stage.offsetHeight + 'px';

        activeSlide.classList.remove('active');
        activeMessage.classList.remove('active');

        stage.dataset.active = act + 1;
        mess.dataset.active = act + 3;

        stage.children[act].classList.add('active');
        mess.children[act+1].classList.add('active');

    }
    toggleSscrollable(el) {
        if (el.classList.contains('overflow-hidden')) {
            el.classList.remove('overflow-hidden');
        }
        else {
            el.classList.add('overflow-hidden');
        }
    }
    toggleDisplay(el) {
        console.log(el);
        if (el.classList.contains('d-none')) {
            el.classList.remove('d-none');
        }
        else {
            el.classList.add('d-none');
        }
    }
}

export default new SpotTheBall;